import { commentsConstants } from "../constants/comments.constants";
import { removeReactLoader } from '../utils/common.js';
import GoalServices from '../services/goal.services';
import { okrDetailConstants } from "../constants/okr/okrDetails.constants";

let services = new GoalServices();

const updateReactedEmoji = data => dispatch => dispatch({
	type: commentsConstants.UPDATE_REACTED_EMOJI,
	data
});

const updateCommentConfidence = data => dispatch => dispatch({
	type: commentsConstants.GET_NEW_CONFIDENCE_COMMENT,
	data
});

function fetchCommentList(goalId, metricId) {
	let params = {
		goalId,
		metric_id: metricId,
		editDisable: true
	}
	// Returned so callers can await the round trip; without it every await here
	// resolves before the response lands.
	return dispatch => {
		return services.fetchCommentList(params)
			.then(response => {
				// WbHttpClient.get resolves with the error object instead of
				// rejecting, and an expired session answers 200 with the SPA HTML
				// shell, so neither failure reaches the catch below. Both have to
				// dispatch a failure or a caller waiting on this KR never settles.
				const payload = response && response.data && response.data.data;
				if (payload) {
					dispatch(successComment(payload));
				} else {
					dispatch(failComment());
				}
			})
			.catch(() => {
				dispatch(failComment());
			});
		// metricId identifies the KR the response was requested for, which the
		// reducer needs because the comment list it writes to is not keyed by KR.
		function successComment(data) {
			return { type: commentsConstants.GET_COMMENT_LIST_SUCCESS, data, metricId };
		}
		function failComment() {
			return { type: commentsConstants.GET_COMMENT_LIST_FAIL, metricId };
		}
	}
}

function addNewComment(params) {
	return (dispatch, getState) => {
		services.saveComment(params)
			.then(response => {
				if (response.data) {
					dispatch(successNewComment(response.data.data));
					dispatch(updateCommentCount(params));
					removeReactLoader();
				}
			})
			.catch((err) => {
				dispatch(failnewComment());
				removeReactLoader();
			});
		function successNewComment(data) {
			let successData = Object.assign({}, data, params);
			return { type: commentsConstants.GET_NEW_COMMENT_SUCCESS, successData };
		}

		function failnewComment() {
			return { type: commentsConstants.GET_NEW_COMMENT_FAIL };
		}

		function updateCommentCount(params){
			params.actionType = 'add';
			return {type: okrDetailConstants.UPDATE_COMMENT_COUNT, params}
		}
	}
}

function deleteComment(params) {
	return (dispatch, getState) => {
		const comment_id = params.gc_id;
		services.deleteComment(params)
			.then(response => {
				if (response.data) {
					dispatch(successDeleteComment(comment_id));
					dispatch(updateCommentCount(params));
				}
				removeReactLoader();
			})
			.catch((err) => {
				dispatch(failDeleteComment());
			});
		function successDeleteComment(data) {
			let dataObj = {
				data
			};
			let successData = Object.assign({}, dataObj, params);
			return { type: commentsConstants.GET_DELETE_COMMENT_SUCCESS, successData };
		}
		function failDeleteComment() {
			return { type: commentsConstants.GET_DELETE_COMMENT_FAIL };
		}
		function updateCommentCount(params){
			params.actionType = 'sub';
			return {type: okrDetailConstants.UPDATE_COMMENT_COUNT, params}
		}
	}
}

function editComment(params) {
	return (dispatch, getState) => {
		services.saveComment(params)
			.then(response => {
				if (response.data) {
					dispatch(successEditComment(response.data.data))
				}
				removeReactLoader();
			})
			.catch((err) => {
        removeReactLoader();
				dispatch(faileditComment());
			});
		function successEditComment(data) {
			return { type: commentsConstants.GET_EDIT_COMMENT_SUCCESS, data };
		}
		function faileditComment() {
			return { type: commentsConstants.GET_EDIT_COMMENT_FAIL };
		}
	}
}

function mentionUser(data) {
	return dispatch => {
		services.getMentionUserList(data).then(response => {
			if (response.data.error) {
				dispatch(failure(error));
			} else {
				dispatch(success(response.data));
			}
		}).catch(error => {
			//dispatch(failure(error));
		})

		function success(data) {
			return { type: krdetailConstants.MENTION_USER_LISTS, data }
		}

		function failure(error) {
			console.log('metioned user search API failure', error);
		}
	}
}

const updateMentionedUserList = data => dispatch => dispatch({
	type: krdetailConstants.MENTION_USER_LISTS,
	data
});

function mentionUserEmpty() {
	return dispatch => {
		dispatch(success());
		function success() {
			return { type: krdetailConstants.MENTION_USER_LISTS_EMPTY }
		}
	}
}

function okrFetchCommentList(goalid, metricid, refSrc, type) {
	let params = {
		goalId: goalid,
		metric_id: metricid,
		editDisable: true
	}
	if (refSrc) {
		params.refSrc = refSrc;
		params.type = type;
	}
	return dispatch => {
		services.fetchCommentList(params)
			.then(response => {
				if (response.data) {
					dispatch(successComment(response.data.data));
				}
			})
			.catch((err) => {
				dispatch(failComment());
			});

		function successComment(data) {
			let successData = Object.assign({}, data, params);
			return { type: commentsConstants.OKR_GET_COMMENT_LIST_SUCCESS, successData };
		}
		function failComment() {
			return { type: commentsConstants.OKR_GET_COMMENT_LIST_FAIL };
		}
	}
}

function editConfidenceComment(params) {
	return (dispatch, getState) => {
		services.saveConfidenceComment(params)
			.then(response => {
				if (response.data) {
					dispatch(successEditComment(response.data))
				}
				removeReactLoader();
			})
			.catch((err) => {
				dispatch(faileditComment());
				removeReactLoader();
			});
		function successEditComment(data) {
			return { type: commentsConstants.GET_EDIT_CONFIDENCE_COMMENT_SUCCESS, data };
		}
		function faileditComment() {
			return { type: commentsConstants.GET_EDIT_CONFIDENCE_COMMENT_FAIL };
		}
	}
}

function getViewableMetricIds(dashboardMetricIds = null) {
	const params = dashboardMetricIds ? { metricIds: dashboardMetricIds.join(',') } : undefined;

	return dispatch => {
		services.getViewableMetricIds(params)
			.then(response => {
				if (response.data) {
					dispatch(success(response.data.metrics));
				}
				removeReactLoader(); // <!-- this is firing before the spinner gets added
			})
			.catch(() => {
				dispatch(fail());
				removeReactLoader();
			});
		function success(data) {
			let successData = { viewableMetricIds: data };
			return { type: commentsConstants.GET_VIEWABLE_METRIC_IDS_SUCCESS, successData };
		}
		function fail() {
			return { type: commentsConstants.GET_VIEWABLE_METRIC_IDS_FAIL };
		}
	}
}

export const commentActions = {
	fetchCommentList,
	addNewComment,
	deleteComment,
	editComment,
	updateReactedEmoji,
	mentionUser,
	mentionUserEmpty,
	updateMentionedUserList,
	okrFetchCommentList,
	updateCommentConfidence,
	editConfidenceComment,
	getViewableMetricIds,
}